// This file is generated by pnpm icons:generate. Do not edit.

import {Earth_Stroke2_Corner0_Rounded as CanonicalEarth_Stroke2_Corner0_Rounded} from './Earth'
import {Earth_Stroke2_Corner2_Rounded as CanonicalEarth_Stroke2_Corner2_Rounded} from './Earth'
import {createSinglePathSVG} from './TEMPLATE'

export const Globe_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25h0A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM20.25 12a8.2 8.2 0 0 1-.312 2.25h-3.61a14.8 14.8 0 0 0 0-4.5h3.61A8.2 8.2 0 0 1 20.25 12ZM9.563 15.75h4.874A10.8 10.8 0 0 1 12 19.969a10.8 10.8 0 0 1-2.437-4.219Zm-.366-1.5a13.2 13.2 0 0 1 0-4.5h5.614a13.2 13.2 0 0 1 0 4.5ZM3.75 12a8.2 8.2 0 0 1 .312-2.25h3.61a14.8 14.8 0 0 0 0 4.5h-3.61A8.2 8.2 0 0 1 3.75 12Zm10.688-3.75H9.561A10.8 10.8 0 0 1 12 4.031a10.8 10.8 0 0 1 2.438 4.219Zm4.905 0h-3.339a12.7 12.7 0 0 0-2.09-4.275 8.28 8.28 0 0 1 5.433 4.275Zm-9.256-4.275A12.7 12.7 0 0 0 7.996 8.25H4.653a8.28 8.28 0 0 1 5.434-4.275ZM4.653 15.75h3.343a12.7 12.7 0 0 0 2.09 4.275 8.28 8.28 0 0 1-5.433-4.275Zm9.26 4.275a12.7 12.7 0 0 0 2.091-4.275h3.343a8.28 8.28 0 0 1-5.434 4.275Z',
  viewBox: '0 0 24 24',
  glyph: 'Globe_Stroke2_Corner0_Rounded',
})

/** @deprecated Import Earth_Stroke2_Corner0_Rounded from `#/components/icons/Earth` instead. */
export const Earth_Stroke2_Corner0_Rounded =
  CanonicalEarth_Stroke2_Corner0_Rounded

/** @deprecated Import Earth_Stroke2_Corner2_Rounded from `#/components/icons/Earth` instead. */
export const Earth_Stroke2_Corner2_Rounded =
  CanonicalEarth_Stroke2_Corner2_Rounded
